import { render, staticRenderFns } from "./MatchTeam.vue?vue&type=template&id=b657b354&scoped=true"
import script from "./MatchTeam.vue?vue&type=script&lang=js"
export * from "./MatchTeam.vue?vue&type=script&lang=js"
import style0 from "./MatchTeam.vue?vue&type=style&index=0&id=b657b354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b657b354",
  null
  
)

export default component.exports